import { create } from 'zustand';

interface JobState {
    selectedStoreJobId: number | null;
    setSelectedStoreJobId: (id: number | null) => void;
}

export const useJobStore = create<JobState>((set) => ({
    selectedStoreJobId: null,
    setSelectedStoreJobId: (id) => set({ selectedStoreJobId: id }),
}));

interface ScrollState {
    sourcePage: string | null;
    selectedScrollPosition: number | null;
    setSelectedSourcePage: (page: string | null) => void;
    setSelectedScrollPosition: (position: number | null) => void;
}

export const useScrollStore = create<ScrollState>((set, get) => ({
    sourcePage: null,
    selectedScrollPosition: null,
    setSelectedSourcePage: (page) => set({ sourcePage: page }),
    setSelectedScrollPosition: (position) => set({ selectedScrollPosition: position }),
}));